import type { PrototypeIconName } from './PrototypeIcon';

const palette = ['#168b9b', '#9a4db0', '#dc593b', '#55833c', '#a47616', '#426cbc'];

/** Identité VISUELLE seulement : ne qualifie jamais une charge fiscalement,
 * ni comme fixe/variable. Le nom conserve son symbole entre tableau et graphe,
 * indépendamment de l'ordre, du montant, du mois et de la connexion source.
 */
export function expenseVisual(name: string): { icon: PrototypeIconName; color: string } {
  const normalized = name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/gu, '')
    .toLowerCase();
  const rules: readonly [RegExp, PrototypeIconName, string][] = [
    [/remuneration|salaire/u, 'wallet', '#b54e79'],
    [/debours/u, 'wallet', '#9a4db0'],
    [/cotisation|urssaf|impot|tva/u, 'coins', '#168b9b'],
    [/abonnement|logiciel|heberg/u, 'network', '#426cbc'],
    [/emprunt|pret/u, 'briefcase-business', '#a47616'],
    [/mutuelle|sante/u, 'life-buoy', '#55833c'],
    [/assurance/u, 'shield-check', '#168b9b'],
    [/publicite|communication/u, 'sparkles', '#dc593b'],
    [/juridique|comptab/u, 'file-text', '#9a4db0'],
  ];
  const match = rules.find(([pattern]) => pattern.test(normalized));
  const hash = [...normalized].reduce(
    (sum, character) => (sum * 31 + character.charCodeAt(0)) >>> 0,
    0,
  );
  return match
    ? { icon: match[1], color: match[2] }
    : { icon: 'coins', color: palette[hash % palette.length]! };
}
